import { Component, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { AuthService } from 'src/app/auth/auth.service';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Company } from 'src/model/company.model';
import { Role } from 'src/model/role.model';

@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.component.html',
    styleUrls: ['./edit-profile.component.scss'],
    standalone: false
})
export class EditProfileComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private _auth = inject(AuthService);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private sharedService = inject(SharedService);

  imgURL: any;
  imageUrls: string[];

  newPassword: string;
  confirmPassword: string;

  loggedInUsername: string;
  loggedInUserRole: string;

  roleList: Role[] = [];
  selectCompanyList: Company[] = [];

  ngOnInit() {
    this.loggedInUsername = sessionStorage.getItem('username');
    // this.getAllRoles();
  }

  handleFileInput(fileList: FileList) {
    // const preview = document.getElementById('preview');
    this.imageUrls = [];

    Array.from(fileList).forEach((file: File) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result);
        this.imageUrls.push(result);
      }
      reader.readAsDataURL(file);
    });
  }

  getSelectedRole(roleID: number) {
    const loggedInRoleID = Number(sessionStorage.getItem("roleId"));
    if (roleID == loggedInRoleID)
      return true;
    else
      return false;
  }

  getSelectedCompany(companyId: number) {
    const loggedInCompanyID = Number(sessionStorage.getItem("companyId"));
    if (companyId == loggedInCompanyID)
      return true;
    else
      return false;
  }

  updateProfile() {
    const error = this.validatePassword();

    if (error != "")
      this.sharedService.openAlert("Oops! Please fix the error(s) before proceed!" + error, ALERT_TYPE.DANGER);
    else {
      this.update();
    }
  }

  update() {
    // var xhr = new XMLHttpRequest();
    // var url = "http://localhost:10080/api/v1/changePassword";
    // xhr.open("PUT", url, true);
    // xhr.setRequestHeader("Content-type", "application/json");
    // xhr.withCredentials = true;

    const data = { "password": this.newPassword };

    const xhr = this.restapi.putRequest(this.constructApi.getChangePassword(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        this.reset();
        this.sharedService.openAlert("Successfully changed password!", ALERT_TYPE.SUCCESS);
        this._auth.logout();
      }
    }
  }

  reset() {
    this.activeModal.close();
    this.newPassword = "";
    this.confirmPassword = "";
  }

  private getAllRoles() {
    // var xhttp = new XMLHttpRequest();
    // var url = "http://localhost:10080/api/v1/roles";
    // xhttp.withCredentials = true;

    const xhttp = this.restapi.getRequest(this.constructApi.getAllRoles())
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        // Typical action to be performed when the document is ready:

        const jsonArray = JSON.parse((xhttp.responseText));
        // console.log(jsonArray);

        jsonArray.forEach(json => {
          // create role instance with all response data
          const role = new Role(json.id, json.name);

          //add role instance into role list
          this.roleList.push(role);
        });
      }
    };
    // xhttp.open("GET", url, true);
    // xhttp.send();
  }

  validatePassword() {
    let errorMessage = "";

    if (this.newPassword == "" || this.confirmPassword == "") {
      errorMessage += "\n❌Don't leave password empty"
    }
    else {
      if (this.newPassword != this.confirmPassword) {
        errorMessage += "\n❌Password doesn't match"
      }

      if (this.newPassword.length < 10) {
        errorMessage += "\n❌Password length must be more than 10 characters"
      }
    }
    return errorMessage;
  }
}
